import springJsonServer from "./springJsonServer";

const restClient = springJsonServer("/api");
export default (type, resource, params) => restClient(type, resource, params);
